import React, { useEffect, useState } from "react";
import { render } from "react-dom";
import useSWR from "swr";
import "./estilo.scss";

const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
const dias = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

const fetcher = (url) => {
	return fetch(url).then(r => r.json());
};

const Expediente = ({data, urlFile}) => {
	const [open, setOpen] = useState(false);
	const { apertura, codigo_rubro, descripcion_rubro, expediente, items } = data;
	return(
		<div className={`expediente${open ? " visible" : ""}`} onClick={() => setOpen((prev) => !prev)}>
			<div className="nro">{expediente}</div>
			<div className="rubro">(Rubro Nro: {codigo_rubro}) {descripcion_rubro.toLowerCase()}</div>
			<div className="cierre">{apertura}</div>
			<div className="icono"></div>
			<ul className="items">
				{
					items.map((item, index) => {
						return(
							<li key={`exp-item-${index}`} className="item">
								<div className="item-nro">#{item.nro_item.padStart(3, "0")}</div>
								<p className="item-articulo">{item.articulo.toLowerCase()}</p>
								<div className="item-cantidad">{item.cantidad}</div>
							</li>
						)
					})
				}
			</ul>
			{
				data.archivos.length > 0 ?
				<div className="archivos">
					<h5>Adjuntos</h5>
					<div className="archivos-body">
						{
							data.archivos.map((archivo, index) => {
								return <a key={`f-${index}`} href={`${urlFile}/${archivo}`} target="_blank" rel="noopener noreferrer">{archivo}</a>
							})
						}
					</div>
				</div>
				:
				""
			}
		</div>
	);
};

const Home = () => {
	const [urls, setUrls] = useState({
		mvm: null,
		osm: null
	});

	const [urlFiles, setUrlFiles] = useState({
		mvm: null,
		osm: null
	});

	const [fechaHora, setFechaHora] = useState(null);

	const { data: mvm, error: errormvm } = useSWR(() => urls.mvm ? urls.mvm : null, fetcher, { refreshInterval: 60000 });
	const { data: osm, error: errorosm } = useSWR(() => urls.osm ? urls.osm : null, fetcher, { refreshInterval: 60000 });

	useEffect(() => {
		let widget = document.getElementById("widget-contrataciones");
		let w_url_mvm = widget.dataset.urlmvm;
		let w_url_osm = widget.dataset.urlosm;
		setUrls({
			mvm: w_url_mvm,
			osm: w_url_osm
		});
		let w_url_files_mvm = widget.dataset.filesmvm;
		let w_url_files_osm = widget.dataset.filesosm;
		setUrlFiles({
			mvm: w_url_files_mvm,
			osm: w_url_files_osm
		});
	}, []);

	useEffect(() => {
		const getFH = () => {
			let today = new Date();
			setFechaHora(`${dias[today.getDay()]}, ${today.getDate()} de ${meses[today.getMonth()]} de ${today.getFullYear()} (${today.getHours().toString().padStart(2, "0")}:${today.getMinutes().toString().padStart(2, "0")} hs.)`);
		};
		let ciclo = setInterval(getFH, 5000);
		getFH();
		return () => {
			clearInterval(ciclo);
		};
	}, []);

	/*
	if(!data && !error) {
		return <div className="lds-dual-ring"></div>
	}
	*/
	
	return(
		<div className="widget">
			{/*
			<div className="widget-header">
				<h1>Solicitudes de Cotización Vigentes</h1>
				<svg className="mun active" version="1.1" viewBox="0 0 69.614 39.057" xmlns="http://www.w3.org/2000/svg">
					<g transform="translate(-52.742 -24.662)">
						<g className="txt-cm" transform="translate(-.89734 .43428)">
							<path d="m98.92 45.434c0-3.8562-3.126-6.9825-6.9822-6.9825-3.8562 0-6.9822 3.1263-6.9822 6.9825h-2.6e-4c0-2.6204-0.86642-5.038-2.328-6.9829 2.123-2.8261 5.5033-4.6546 9.3105-4.6546 3.8068 0 7.1868 1.8281 9.3098 4.6538-1.4616 1.9452-2.3276 4.3632-2.3276 6.9836"/>
							<path d="m122.2 45.434h-4.6549c0-3.8562-3.1263-6.9825-6.9825-6.9825-3.8562 0-6.9825 3.1263-6.9825 6.9825h-4.6552 4.6552c0-2.6204-0.86606-5.0384-2.3276-6.9836 2.1234-2.8257 5.5033-4.6538 9.3102-4.6538 6.4273 0 11.637 5.2102 11.637 11.637"/>
							<path d="m64.007 26.084c-1.065-1.0647-2.7912-1.0647-3.8559 0-1.0647 1.065-1.0647 2.7912 0 3.8559l3.8566 3.8566 0.77082-0.77117 3.0854-3.0854c1.0647-1.0647 1.0647-2.7908 0-3.8559-1.0647-1.0647-2.7912-1.0647-3.8555 0h-1e-3"/>
							<path d="m84.955 45.434h-4.6549c0-3.2311-2.195-5.9485-5.1752-6.7451l1.2047-4.4965c2.5502 0.68156 4.7551 2.207 6.2974 4.2587-1.4612 1.9452-2.3269 4.3628-2.3269 6.9829h4.6549"/>
						</g>
						<g className="txt-somos" transform="translate(-.89734 .43428)">
							<path d="m60.533 60.607h8.4307v1.6192h-8.4307v-1.6192"/>
							<path d="m68.686 58.528 1.7448-2.08c1.0608 0.80962 2.2751 1.1444 3.4198 1.1444 0.58596 0 0.83714-0.15346 0.83714-0.4184v-0.0279c0-0.2794-0.30692-0.43286-1.354-0.64241-2.1915-0.44661-4.1176-1.0746-4.1176-3.1404v-0.0279c0-1.8567 1.452-3.2942 4.1455-3.2942 1.8845 0 3.2805 0.44697 4.4108 1.3402l-1.591 2.2052c-0.92111-0.66992-2.0239-0.96343-2.9312-0.96343-0.4886 0-0.71191 0.16792-0.71191 0.40499v0.0279c0 0.26528 0.26529 0.43286 1.2982 0.62829 2.4984 0.46073 4.1734 1.1868 4.1734 3.1545v0.0279c0 2.0518-1.6887 3.308-4.3127 3.308-1.9823 0-3.7687-0.55809-5.0112-1.6468"/>
							<path d="m85.912 55.136v-0.0282c0-1.1585-0.79586-2.2052-2.0521-2.2052-1.2421 0-2.0239 1.0329-2.0239 2.1774v0.0279c0 1.1589 0.79551 2.2056 2.0518 2.2056 1.2425 0 2.0242-1.0326 2.0242-2.1773zm-7.3702 0v-0.0282c0-2.8332 2.3308-5.0945 5.346-5.0945 3.0148 0 5.3178 2.2334 5.3178 5.0666v0.0279c0 2.8339-2.3308 5.0948-5.3456 5.0948-3.0152 0-5.3181-2.2331-5.3181-5.0666"/>
							<path d="m90.101 50.223h3.4054l2.0937 3.4336 2.0937-3.4336h3.4057v9.7705h-3.2519v-4.8433l-2.2476 3.4752h-0.0557l-2.2472-3.4752v4.8433h-3.1962v-9.7705"/>
							<path d="m109.36 55.136v-0.0282c0-1.1585-0.79586-2.2052-2.0518-2.2052-1.2425 0-2.0242 1.0329-2.0242 2.1774v0.0279c0 1.1589 0.79551 2.2056 2.0521 2.2056 1.2421 0 2.0239-1.0326 2.0239-2.1773zm-7.3702 0v-0.0282c0-2.8332 2.3312-5.0945 5.3464-5.0945 3.0148 0 5.3178 2.2334 5.3178 5.0666v0.0279c0 2.8339-2.3312 5.0948-5.3456 5.0948-3.0152 0-5.3185-2.2331-5.3185-5.0666"/>
							<path d="m112.67 58.528 1.7445-2.08c1.0608 0.80962 2.2751 1.1444 3.4198 1.1444 0.58631 0 0.83749-0.15346 0.83749-0.4184v-0.0279c0-0.2794-0.30727-0.43286-1.354-0.64241-2.1914-0.44661-4.1176-1.0746-4.1176-3.1404v-0.0279c0-1.8567 1.4517-3.2942 4.1455-3.2942 1.8845 0 3.2805 0.44697 4.4108 1.3402l-1.591 2.2052c-0.9211-0.66992-2.0239-0.96343-2.9316-0.96343-0.48824 0-0.71155 0.16792-0.71155 0.40499v0.0279c0 0.26528 0.26529 0.43286 1.2979 0.62829 2.4984 0.46073 4.1737 1.1868 4.1737 3.1545v0.0279c0 2.0518-1.6891 3.308-4.3131 3.308-1.9819 0-3.7687-0.55809-5.0109-1.6468"/>
						</g>
						<g className="txt-v" transform="translate(-.89734 .43428)">
							<path d="m66.335 45.434c0-2.6204-0.86572-5.0384-2.3273-6.9836 2.123-2.8257 5.5033-4.6538 9.3098-4.6538v4.6549c-3.8562 0-6.9825 3.1263-6.9825 6.9825"/>
							<path d="m66.335 45.434h-4.6549c0-3.8562-3.1263-6.9825-6.9825-6.9825v-4.6549c3.8068 0 7.1868 1.8281 9.3102 4.6538-1.4616 1.9452-2.3276 4.3632-2.3276 6.9836h4.6549"/>
						</g>
						<path className="txt-v" d="m65.438 45.868h-4.6549c0-2.6204 0.86606-5.0384 2.3276-6.9836 1.4616 1.9452 2.3273 4.3632 2.3273 6.9836"/>
						<g className="txt-cm" transform="translate(-.89734 .43428)">
							<path d="m103.58 45.434h-4.6552c0-2.6204 0.86607-5.0384 2.3276-6.9836 1.4616 1.9452 2.3276 4.3632 2.3276 6.9836"/>
							<path d="m64.779 26.855c0.63888-0.63888 1.6746-0.63888 2.3135 0 0.63888 0.63888 0.63888 1.675 0 2.3135l3.5e-4 3.5e-4 -3.0854 3.0854-3.0854-3.0854v-3.4e-4c-0.63888-0.63853-0.63888-1.6746 0-2.3135 0.63888-0.63888 1.6746-0.63888 2.3132 0h3.5e-4l0.77117 0.77117 0.77082-0.77117h1e-3"/>
							<path d="m84.955 45.434h-4.6549c0-2.6201 0.86571-5.0377 2.3269-6.9829 1.4616 1.9449 2.328 4.3624 2.328 6.9829"/>
						</g>
					</g>
				</svg>
				<p>A continuación se presenta el listado de las solicitudes de cotización vigentes, Sr. Proveedor, si Ud. está inscripto en alguno de estos rubros no desaproveche la oprtunidad.</p>
			</div>
			*/}
			<div className="widget-body">
				<div className="expediente-fh">{`Municipalidad de Villa Mercedes (S.L.), ${fechaHora}`}</div>
				{
					!mvm && !errormvm ?
					<div className="widget-error"><div className="lds-dual-ring"></div></div>
					:
					errormvm ?
					<div className="widget-error">Estamos realizando tareas de matenimiento, presentaremos la información a la brevedad posible.</div>
					:
					<>
						<div className="expediente titulo">
							<div className="nro">Nro. Exp</div>
							<div className="rubro">Rubro</div>
							<div className="cierre">Finaliza</div>
							<div className="icono"></div>
						</div>
						<div className="widget-scroll">
						{
							mvm.expedientes.map((expediente, index) => <Expediente key={`exp-${index}`} data={expediente} urlFile={urlFiles.mvm} />)
						}
						</div>
					</>
				}
			</div>
			<hr/>
			<div className="widget-body">
				<div className="expediente-fh">{`Obras Sanitarias Mercedes (S.L.), ${fechaHora}`}</div>
				{
					!osm && !errorosm ?
					<div className="widget-error"><div className="lds-dual-ring"></div></div>
					:
					errorosm ?
					<div className="widget-error">Estamos realizando tareas de matenimiento, presentaremos la información a la brevedad posible.</div>
					:
					<>
						<div className="expediente titulo">
							<div className="nro">Nro. Exp</div>
							<div className="rubro">Rubro</div>
							<div className="cierre">Finaliza</div>
							<div className="icono"></div>
						</div>
						<div className="widget-scroll">
						{
							osm.expedientes.map((expediente, index) => <Expediente key={`exp-${index}`} data={expediente} urlFile={urlFiles.osm} />)
						}
						</div>
					</>
				}
			</div>
			<div className="widget-footer">
				<p>La información es actualizada, aproximadamente, cada 1 minuto.</p>
				<p>La disponibilidad de la información presentada puede estar sujeta a tareas de mantenimiento y desperfectos técnicos.</p>
			</div>
		</div>
	);
};

render(<Home />, document.getElementById("widget-contrataciones"));